module.exports = __webpack_public_path__ + "static/illustration@2x-85cce263ddf60035c6702cc57dd1fc2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/contact-us/illustration@2x.jpg
// module id = 2547
// module chunks = 221662759943617